import { render, staticRenderFns } from "./catalogueLeft.vue?vue&type=template&id=06197b80&scoped=true&"
import script from "./catalogueLeft.vue?vue&type=script&lang=js&"
export * from "./catalogueLeft.vue?vue&type=script&lang=js&"
import style0 from "./catalogueLeft.vue?vue&type=style&index=0&id=06197b80&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06197b80",
  null
  
)

export default component.exports